/* Colore accento del carrello = colore del PRIMO prodotto aggiunto.
   Registrato quando il carrello passa da vuoto al primo prodotto (a quel punto
   e' presente solo quello), memorizzato in sessione, azzerato a carrello vuoto.
   Indipendente dal percorso di aggiunta e dall'ordine di cart.items. */
(function () {
  var KEY = 'avra_cart_accent';
  var VAR = '--avra-cart-accent';
  var BY_VARIANT = {
    '44370639847466': '#5C1B26', // Avra per Lei  -> rosso
    '44370639257642': '#1F2A44', // Avra per Lui  -> blu
    '44370905038890': '#C99B6E'  // Avra Body Oil -> giallo
  };
  var BY_HANDLE = {
    'avra-per-lei': '#5C1B26',
    'avra-per-lui': '#1F2A44',
    'body-oil': '#C99B6E'
  };
  var fetching = false;

  function get() { try { return sessionStorage.getItem(KEY) || ''; } catch (e) { return ''; } }
  function set(c) { try { if (c) sessionStorage.setItem(KEY, c); else sessionStorage.removeItem(KEY); } catch (e) {} }

  function apply() {
    var color = get();
    if (!color) return; // niente memorizzato -> lascia il valore SSR del liquid (non azzerare a nero)
    var inner = document.querySelector('.drawer__inner');
    if (inner) inner.style.setProperty(VAR, color);
  }

  // Registrazione rapida per variant (percorsi che controllo). No-op se gia' impostato.
  window.avraRecordAccentVariant = function (vid) {
    if (get()) return;
    var c = BY_VARIANT[String(vid)];
    if (c) { set(c); apply(); }
  };

  function syncFromCart(cart) {
    if (!cart || typeof cart.item_count !== 'number') return;
    if (!cart.item_count) { set(''); return; }              // carrello vuoto -> azzera
    if (!get()) {                                           // primo prodotto in carrello -> registra il suo colore
      var h = cart.items[0] && cart.items[0].handle;
      if (BY_HANDLE[h]) set(BY_HANDLE[h]);
    }
    apply();
  }

  // Assicura il colore: se non memorizzato (o per rilevare lo svuotamento) legge il carrello.
  function ensureAndApply(forceCheck) {
    if (get() && !forceCheck) { apply(); return; }
    if (fetching) return;
    fetching = true;
    fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { syncFromCart(cart); })
      .catch(function () {})
      .then(function () { fetching = false; });
  }

  // Dawn pub/sub: aggiunte e modifiche quantita'
  function hookPubSub() {
    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
      subscribe(window.PUB_SUB_EVENTS.cartUpdate, function (ev) {
        if (ev && ev.productVariantId) window.avraRecordAccentVariant(ev.productVariantId);
        if (ev && ev.cartData && typeof ev.cartData.item_count === 'number') syncFromCart(ev.cartData);
        else ensureAndApply(true); // verifica anche svuotamenti
      });
      return true;
    }
    return false;
  }
  if (!hookPubSub()) {
    var tries = 0;
    var iv = setInterval(function () { if (hookPubSub() || ++tries > 25) clearInterval(iv); }, 150);
  }

  // Ogni re-render del drawer (qualsiasi percorso di aggiunta) -> registra/applica
  var cd = document.getElementById('CartDrawer');
  if (cd && window.MutationObserver) {
    new MutationObserver(function () { ensureAndApply(false); }).observe(cd, { childList: true, subtree: true });
  }

  document.addEventListener('DOMContentLoaded', function () {
    apply();
    ensureAndApply(true);
  });
})();
